import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={180}
    height={props.width? `calc( ${props.width}/ 180 * 155 )`: 155}
      viewBox="0 0 180 155"
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      d="m134.712.49 44.71 77.01-44.71 77.009H45.288L.578 77.5 45.288.49h89.424Z"
    />
  </svg>
)
export default SvgComponent
